@if (nodes && nodes.length) {
  <ps-hierarchy (selectionChanged)="setSelected($event)" id="orgUnits">
    @for (node of nodes; track node) {
      <ps-hierarchy-node [class]="'hierarchy-node'" [node]="node" [level]="0">
        {{node.name}}
      </ps-hierarchy-node>
    }
  </ps-hierarchy>
}
